import { fetchApi } from '../client';
import type {
  DoctorDashboardSummaryDto,
  DoctorQueueItemDto,
  DoctorActionRequiredDto,
  DoctorClinicalAlertDto,
  DoctorLabReviewItemDto,
  DoctorFollowUpItemDto,
  DoctorAiReviewItemDto,
} from '../../../types';

export const doctorDashboardModule = {
  getSummary: () =>
    fetchApi<DoctorDashboardSummaryDto>('/api/doctor-dashboard/summary'),

  getQueue: () =>
    fetchApi<{ data: DoctorQueueItemDto[]; count: number }>('/api/doctor-dashboard/queue'),

  getActions: () =>
    fetchApi<{ data: DoctorActionRequiredDto[]; count: number }>('/api/doctor-dashboard/actions'),

  getAlerts: () =>
    fetchApi<{ data: DoctorClinicalAlertDto[]; count: number }>('/api/doctor-dashboard/alerts'),

  getLabReview: () =>
    fetchApi<{ data: DoctorLabReviewItemDto[]; count: number }>('/api/doctor-dashboard/lab-review'),

  getFollowUps: () =>
    fetchApi<{ data: DoctorFollowUpItemDto[]; count: number }>('/api/doctor-dashboard/follow-ups'),

  getAiReview: () =>
    fetchApi<{ data: DoctorAiReviewItemDto[]; count: number }>('/api/doctor-dashboard/ai-review'),
};
